import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { LoggingMessageService } from 'src/app/services/logging-message.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { UserNavigationService } from 'src/app/services/user-navigation.service';
import { AuthService } from 'src/app/services/auth.service';
import { SubscriptionChangeService } from 'src/app/services/subscription-change.service';

@Component({
    standalone: true,
    selector: 'app-different-domain',
    templateUrl: './different-domain.component.html'
})

export class DifferentDomainComponent implements OnInit, OnDestroy {
    private $subscriptions: Subscription = new Subscription();
    private linkid: string;
    selectedSubscriptionID: number;
    availableSubscriptions: string;

    get isDevelopment(): boolean {
        return (environment.production === false);
    }

    constructor(private router: Router,
        private route: ActivatedRoute,
        private logger: LoggingMessageService,
        private sessionService: SessionStorageService,
        private navigationService: UserNavigationService,
        private authService: AuthService,
        private subscriptionService: SubscriptionChangeService) {

        const navigationSubscription = this.router.events
            .subscribe((e: any) => {
                // If it is a NavigationEnd event display the report
                if (e instanceof NavigationEnd) {
                    this.handleNavigationEvent(e);
                }
            });
        this.$subscriptions.add(navigationSubscription);
    }

    ngOnInit() {
        this.selectedSubscriptionID = this.subscriptionService.SelectedSubscription;
        this.availableSubscriptions = this.subscriptionService.AvailableSubscriptionsString;
    }

    private updateLinkId() {
        const linkId = this.route.snapshot.queryParams.linkid;
        if (linkId) {
            this.linkid = linkId;
        }
    }

    private setWindowSource() {
        let url = this.route.snapshot.queryParams.url;
        if (url) {
            const user = this.authService.getUser();
            this.logger.info('different-domain', 'setWindowSource', this.selectedSubscriptionID, this.availableSubscriptions, `Href: ${url}`, '');
            const communities = this.route.snapshot.queryParams.com;
            if (communities) {
                url = url + 'com=' + communities;
            }
            // window.location.href = url;
            window.open(url, '_blank');
            this.navigationService.emitNavigationComplete(this.linkid);
        }
    }

    private loadPage() {
        const loggedIn = this.authService.isUserLoggedIn();
        // if ((loggedIn === true) || (environment.UseTestToken === true) ) {
        if (loggedIn === true) {
            this.setWindowSource();
        } else {
            // ?
        }
    }

    private handleNavigationEvent(e: NavigationEnd) {
        this.updateLinkId();
        this.loadPage();
        this.logger.debug('different-domain', 'handleNavigationEvent',  this.selectedSubscriptionID, this.availableSubscriptions, `Changing NavLink id: ${this.linkid}`, '');
    }


    private Unsubscribe() {
        if (this.$subscriptions) {
          this.$subscriptions.unsubscribe();
        }
      }

    ngOnDestroy(): void {
        this.Unsubscribe();
    }

}
